const REEDED_VARIANTS = [
  {
    objectName: 'SUPPORT_REEDED_SINGLE_SMALL',
    maxTopWidth: 55,
    sizing: {
      scaleZero: 18.25,
      scaleOne: 28.25,
      feetThickness: 5.679,
      feetThicknessScaleOne: 8.237,
      baseThickness: 5.679,
      baseThicknessScaleOne: 8.237,
      baseThicknessCenterY: 15,
      baseThicknessCenterYScaleOne: 15,
    },
  },
  {
    objectName: 'SUPPORT_REEDED_SINGLE_MEDIUM',
    maxTopWidth: 75,
    sizing: {
      scaleZero: 22.75,
      scaleOne: 32.77,
      feetThickness: 6.431,
      feetThicknessScaleOne: 9.095,
      baseThickness: 6.431,
      baseThicknessScaleOne: 9.095,
      baseThicknessCenterY: 15,
      baseThicknessCenterYScaleOne: 15,
    },
  },
  {
    objectName: 'SUPPORT_REEDED_SINGLE_LARGE',
    maxTopWidth: Infinity,
    sizing: {
      scaleZero: 28.75,
      scaleOne: 38.75,
      feetThickness: 6.595,
      feetThicknessScaleOne: 9.096,
      baseThickness: 6.595,
      baseThicknessScaleOne: 9.096,
      baseThicknessCenterY: 15,
      baseThicknessCenterYScaleOne: 15,
    },
  },
] as const

export function getReededVariant(topWidth: number) {
  return REEDED_VARIANTS.find(v => topWidth <= v.maxTopWidth) ?? REEDED_VARIANTS[2]
}
